import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { WidgetsServiceService } from 'src/app/modules/home/widgets-collection/widgets-service.service';
import { DataService } from 'src/app/services/data.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { ExportTableComponent } from 'src/app/shared/components/dover/export-table/export-table.component';
import { EntitiesServiceService } from 'src/app/shared/services/entities-service.service';

@Component({
  selector: 'app-entities-tabs',
  templateUrl: './entities-tabs.component.html',
  styleUrls: ['./entities-tabs.component.css']
})

export class EntitiesTabsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() tabData: any;
  @Input() config: any;
  @Input() tenantType: any;
  @Input() refreshRate: any;
  @Output() periodFilter = new EventEmitter<any>();
  tabIndex: any;
  insightTabIndex: number = 0; 
  periodList: any = [{ id: 1, name: 'Today' }, { id: 2, name: 'Last 7 days' }, { id: 3, name: 'This month' }, { id: 4, name: 'Last month' }, { id: 5, name: 'Last 3 months' },
  { id: 6, name: 'Last 6 months' }];
  drivingBehaviour: any = [];
  fuel: any = [];
  mileage: any = [];
  speed: any = [];
  activeAlerts: any = [];
  entityUtilization: any[];
  masterMapData: any[];
  period = new FormControl();
  pageSize = new FormControl();
  attributeDataList: any[];
  attributeData: any;
  isloader: boolean = true;
  isError: boolean = false;
  intialTabIndex: number;
  tabStructure: any;
  attributeList: any[] = [];
  pageSizeLimit: any = [];
  showTrend: boolean = false;
  trlConfig: any;
  apiHitTime: Date;

  private _donutColors: any = ['#74d793', '#1687ff', '#eb2f06', 'rgba(212, 180, 255, 1)', '#7efff5'];
  private _today: any = new Date();
  private _startTime: any;
  private _endTime: any;
  private _systemAttributeDataList: any = [];
  private _systemAttributeData: any;
  private _subscription: Subscription;
  private _trendPlot: any = [];
  private _rulStatistictsData: any = [];
  private _afterClosedSubscription: Subscription;
  private _locateEntitySubscription: Subscription;
  private _getEntityAttributeSubscription: Subscription;
  private _getTrendChartDetailsSubscription: Subscription;
  
  constructor(public service: ServicecallService, private _datePipe: DatePipe, private _dialog: MatDialog, private _dataSer: DataService, private _entityService: EntitiesServiceService) {
    this._subscription = _dataSer.events.subscribe((res: any) => {
      if (res.name === 'vitalHistoryRefresh') {
        this.onPeriodFilterChange(this.attributeData);
      } else if (res.name === 'trendUpdate') {
        this.attributeList = res?.args?.length ? [...res?.args[0]] : [];
        this.onPeriodFilterChange(this.attributeList);
      } else if (res.name === 'siteChanged' || res.name === 'apiRefresh') {
        this._trlFetchData();
      }
    });
  }

  ngOnInit(): void {
    this.intialTabIndex = (this.tenantType === 'dover') ? 0 : 100;
    this.pageSizeLimit = this.service.getConfiguration('pageLimits') ? this.service.getConfiguration('pageLimits')?.pageLimits : [];
    this.showTrend = this.service.getConfiguration('tenantCategory') ? this.service.getConfiguration('tenantCategory')?.trend : false;
    this.trlConfig = this.service.getConfiguration('tenantGenericConfig') ? this.service.getConfiguration('tenantGenericConfig') : null;
    this._rulStatistictsData = this.trlConfig?.rulStatisticts?.map(x => Object.assign({}, x));
    this._trlFetchData('initial');
  }
  ngOnChanges() {
    this.period.setValue(this.periodList[0]);
    this.pageSize.setValue(this.pageSizeLimit[0]);
    this._getTabData();
    // this.trlFetchData();
  }

  tabChanged(event: any) {
    this.tabIndex = event.index;
    window.dispatchEvent(new Event('resize'));
  }

  onPageLimitChange() {
    // if (this.trlConfig?.tenant === 'TRL') {
    //   this._rulStatistictsData = this.trlConfig?.rulStatisticts.map(x => Object.assign({}, x));
    // }
    // this.trlFetchData();
  }

  insightsTabChanged(event: any) {
    this.insightTabIndex = event.index;
    window.dispatchEvent(new Event('resize'));
  }

  onPeriodFilterChange(attributeList?: any) {
    this.isloader = true;
    this._endTime = null;
    if (this.trlConfig?.tenant !== 'TRL' && this.trlConfig?.tenant !== 'DMK') {
      switch (this.period?.value?.id) {
        case 1:
          this._startTime = new Date(this._today.getFullYear(), this._today.getMonth(), this._today.getDate(), 0, 0, 0, 999);
          break;
        case 2:
          this._startTime = new Date(this._today.getFullYear(), this._today.getMonth(), this._today.getDate() - 7, 0, 0, 0, 999);
          break;
        case 3:
          this._startTime = new Date(this._today.getFullYear(), this._today.getMonth(), 1, 0, 0, 0, 999);
          break;
        case 4:
          this._startTime = new Date(this._today.getFullYear(), this._today.getMonth() - 1, 1, 0, 0, 0, 999);
          this._endTime = new Date(new Date().getFullYear(), new Date().getMonth(), 0, 23, 59, 59, 999);
          break;
        case 5:
          this._startTime = new Date(this._today.getFullYear(), this._today.getMonth() - 3, 1, 0, 0, 0, 999);
          break;
        case 6:
          this._startTime = new Date(this._today.getFullYear(), this._today.getMonth() - 6, 1, 0, 0, 0, 999);
          break;
      }
    } else {
      switch (this.period?.value?.id) {
        case 1:
          this._startTime = new Date(new Date().setMinutes(new Date().getMinutes() - 15));
          break;
        case 2:
          this._startTime = new Date(new Date().setMinutes(new Date().getMinutes() - 30));
          break;
        case 3:
          this._startTime = new Date(new Date().setMinutes(new Date().getMinutes() - 60));
          break;
      }
    }
    if (this.tabData?._id) {
      if (this.trlConfig?.tenant !== 'TRL' && this.trlConfig?.tenant !== 'DMK')
        this._getAttributeDetails();
      this._trlFetchData();
      this.periodFilter.emit(this.period?.value?.id);
    }
  }
  exportData() {
    const item = { patientId: this.tabData?.uniqueId, patientName: this.tabData?.name, _id: this.tabData?._id, site: this.tabData?.site }
    const dialogRef = this._dialog.open(ExportTableComponent, {
      disableClose: true,
      data: { msg: 'export', exportDetails: item }
    });
    this._afterClosedSubscription = dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._getAttributeDetails();
      }
    });
  }
  showHistory(data: any, event: any, type: any) {
    this._getTrendData(type === 'history' ? true : false, data, event);
  }
  
  getTabTitle(tenant: string) {
    switch (tenant) {
      case 'TRL': return 'Telematics Statistics';
      case 'DMK': return 'Appliance Statistics';
      default: return 'Attributes Statistics';
    }
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    this._afterClosedSubscription?.unsubscribe();  
    this._locateEntitySubscription?.unsubscribe();  
    this._getEntityAttributeSubscription?.unsubscribe();  
    this._getTrendChartDetailsSubscription?.unsubscribe();  
  }

  private _trlFetchData(type: string = 'change') {
    if (this.trlConfig?.tenant === 'TRL' || this.trlConfig?.tenant === 'DMK') {
      if (type === 'initial') {
        this.periodList = [{ id: 1, name: 'Last 15 mins' }, { id: 2, name: 'Last 30 mins' }, { id: 3, name: 'Last 1 hour' }];
        this.intialTabIndex = 0;
        this.tabIndex = 0;
        // } else {
        //   this.apiHitTime = new Date();
        //   this.getRulStatistics('brake');
        //   this.getRulStatistics('clutch');
        // this.activeEntityDetails(this.currentStatHistoryPage);
      }
    }
  }
  private _getTabData() {
    this.onPeriodFilterChange(this.attributeList);
    if (this.tabData?.entityBehaviour) {
      const xValue: any = Object.values(this.tabData?.entityBehaviour);
      const yValue: any = Object.keys(this.tabData?.entityBehaviour);
      const xValue2: any = xValue.map(val => { return 100 - val })
      this.drivingBehaviour = [{
        y: yValue, x: xValue, type: 'bar', marker: {
          color: '#74d793',
          width: 1
        },
        width: .5,
        orientation: 'h',
        barmode: 'stack',
        title: '',
        margin: {
          l: 80,
          r: 10,
          b: 30,
          t: 0,
          pad: 10
        },
        barColor: '#f6f6f6'
      },
      {
        y: yValue,
        x: xValue2,
        type: 'bar',
        marker: {
          color: '#1687ff',
          width: 1
        },
        width: .5,
        orientation: 'h',
        barmode: 'stack',
        title: '',

      }];
    } else {
      this.drivingBehaviour = [];
    }

    if (this.tabData?.map) {
      this.mileage = [{
        x: this.tabData?.map[0].dataSet.map(({ date }) => date = new DatePipe('en-US').transform(date, 'yyyy-MM-dd')),
        y: this.tabData?.map[0].dataSet.map(({ value }) => value),
        mode: 'lines+markers',
        connectgaps: true,
        title: '',
        margin: {
          l: 30,
          r: 10,
          b: 30,
          t: 0
        }
      }];

      this.speed = [{
        x: this.tabData?.map[1].dataSet.map(({ date }) => date = new DatePipe('en-US').transform(date, 'yyyy-MM-dd')),
        y: this.tabData?.map[1].dataSet.map(({ value }) => value),
        mode: 'lines+markers',
        connectgaps: true,
        title: '',
        margin: {
          l: 30,
          r: 10,
          b: 30,
          t: 0
        }
      }];

      this.fuel = [{
        x: this.tabData?.map[2].dataSet.map(({ date }) => date = new DatePipe('en-US').transform(date, 'yyyy-MM-dd')),
        y: this.tabData?.map[2].dataSet.map(({ value }) => value),
        mode: 'lines+markers',
        connectgaps: true,
        title: '',
        margin: {
          l: 30,
          r: 10,
          b: 30,
          t: 0
        }
      }];
    }
    else {
      this.mileage = [];
      this.speed = [];
      this.fuel = [];
    }

    if (this.tabData?.activeAlertDetails) {
      this.activeAlerts = [
        {
          x: this.tabData?.activeAlertDetails.map(({ date }) => date = new DatePipe('en-US').transform(date, 'dd/MM/yyyy')),
          y: this.tabData?.activeAlertDetails.map(({ mechanicalAlertCount }) => mechanicalAlertCount),
          type: 'bar',
          marker: {
            color: '#74d793',
            width: 1
          },
          width: .5,
          title: '',
          barmode: 'stack',
          margin: {
            l: 20,
            r: 10,
            b: 30,
            t: 0,
            pad: 5
          },
          range: null,
          barColor: '#f6f6f6'
        },
        {
          x: this.tabData?.activeAlertDetails.map(({ date }) => date = new DatePipe('en-US').transform(date, 'dd/MM/yyyy')),
          y: this.tabData?.activeAlertDetails.map(({ trafficAlertCount }) => trafficAlertCount),
          type: 'bar',
          marker: {
            color: '#1687ff',
            width: 1
          },
          title: '',
          barmode: 'stack',
          width: .5,
          margin: {
            l: 20,
            r: 10,
            b: 30,
            t: 0,
            pad: 10
          },
          range: null
        }
      ];
    }
    else {
      this.activeAlerts = [];
    }

    if (this.tabData?.entityUtilization) {
      this.entityUtilization = [];
      const donut = { values: [], labels: [], type: 'pie', hole: .5, title: "", legend: true, barColor: '#f6f6f6', marker: { colors: this._donutColors } };
      donut.values = Object.values(this.tabData?.entityUtilization);
      donut.labels = Object.keys(this.tabData?.entityUtilization);
      this.entityUtilization.push(donut);
    }
    else {
      this.entityUtilization = [];
    }
    if (this.tabData?._id && this.tabData?.type === 1) {
      if (this.trlConfig?.tenant !== 'TRL' && this.trlConfig?.tenant !== 'DMK')
        this._getGeoHistory();
    }
  }

  private _getGeoHistory() {
    const requestData = {
      entityId: this.tabData?._id,
      from: this._datePipe.transform(new Date(this._today.setMinutes(this._today.getMinutes() - 15)), 'yyyy-MM-ddTHH:mm:ssZ'),
      to: this._datePipe.transform(this._endTime ? this._endTime : Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ'),
    };
    this._locateEntitySubscription = this.service.locateEntity(requestData).subscribe((resp: any) => {
      if (resp?.status) {
        const enitityCords = resp.response.data[0].coordinates;
        this.masterMapData = [{
          polygonData: enitityCords.map(({ lat, long }) => { return [lat, long] })
        }];
      } else {
        this.masterMapData = [];
        if (resp?.response?.message)
          this.service.toasterService({ type: 'error', msg: resp?.response?.message });
      }
    });
  }
  private _getAttributeDetails() {
    this._trendPlot = [];
    if (this.trlConfig?.tenant !== 'TRL' && this.trlConfig?.tenant !== 'DMK')
      this.tabStructure = this.service.getConfiguration('tabStructure') ? this.service.getConfiguration('tabStructure') : {};
    else
      this.tabStructure = null;
    if (this.tabStructure?.tabs?.length) {
      const requestData = {
        entityId: this.tabData?._id,
        from: this._datePipe.transform(this._startTime, 'yyyy-MM-ddTHH:mm:ssZZ'),
        to: this._datePipe.transform(this._endTime ? this._endTime : Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ'),
        siteId: this.service.getSiteId()
      };
      this.apiHitTime = new Date();
      this.isError = false;
      this._getEntityAttributeSubscription = this.service.getEntityAttribute(requestData).subscribe({
        next: (resp: any) => {
          if (resp?.status) {
            if (resp?.response?.data) {
              this.attributeDataList = [];
              this._systemAttributeDataList = [];
              this.attributeData = this.service.flattenObject(resp?.response?.data);
              if (this.attributeData) {
                this._plotAttributeGraph();
              }
              else {
                this.attributeData = [];
                this.attributeDataList = [];
                this._systemAttributeData = [];
                this._systemAttributeDataList = [];
              }
            } else {
              this.isloader = false;
              this.isError = true;
              this.attributeData = [];
              this.attributeDataList = [];
              this._systemAttributeData = [];
              this._systemAttributeDataList = [];
            }
          }
        },
        error: (error) => {
          if (error) {
            this.isloader = false;
            this.isError = true;
          }
        }
      })
    }
  }
  private _plotAttributeGraph() {
    this.isloader = false;
    this.attributeDataList = [];
    Object.keys(this.attributeData).forEach(element => {
      const attributeAlertLine = { showAttributeLowerLine: false, showAttributeUpperLine: false };
      const windowAlertLine = { showWindowLowerLine: false, showWindowUpperLine: false };
      const attributeDeviceLine = { deviceAttributeLowerLine: false, deviceAttributeUpperLine: false };
      const windowDeviceLine = { deviceWindowLowerLine: false, deviceWindowUpperLine: false };
      this.attributeData[element].map((item: any) => { item.value = parseFloat(item.value); item.windowAvg ? item.windowAvg = parseFloat(item.windowAvg) : undefined })
      const statisticsAttributeData: any = {};
      const maxValue = Math.max(...this.attributeData[element].map(({ value }) => value));
      const minValue = Math.min(...this.attributeData[element].map(({ value }) => value));
      let sumValue: any = 0;
      let meanValue: any;
      let invalidPointCount: any = 0;
      this.attributeData[element].map(({ value }) => value).forEach(value => {
        sumValue += parseFloat(value);
      });
      meanValue = sumValue / (this.attributeData[element].map(({ value }) => value)).length;
      const statistics = { mean: Math.round(meanValue * 100) / 100, largest: maxValue, lowest: minValue };
      let attributeBarData2 = {};
      let attributeBarData3 = {};
      let attributeBarData4 = {};
      const attributeThresholdData = {};
      const attributeBarData = {
        x: this.attributeData[element].map(({ timestamp }) => new Date(timestamp)),
        y: this.attributeData[element].map(({ value }) => value),
        mode: 'lines+markers+text',
        connectgaps: true,
        title: '',
        tabTitle: '',
        margin: { l: 30, r: 10, b: 15, t: 0 },
        width: 900,
        height: 380,
        barColor: 'white',
        name: 'Instantaneous Data',
        legend: this.tabData?.category !== 'patient' ? true : false,
        hovertemplate: '',
        opacity: 1.0,
        line: {
          color: 'rgb(169, 169, 169)'
        },
        textfont: { size: [] },
        marker: { color: '#097969', size: 4 },
        annotations: this.tabData?.category !== 'patient' ? [
          {
            x: new Date((this.attributeData[element].find(element1 => element1.value === maxValue))?.timestamp),
            y: maxValue,
            xref: "x",
            yref: "y",
            text: "Max value=" + maxValue.toString(),
            showarrow: true,
            font: {
              family: "Inter",
              size: 12,
              color: "#ffffff"
            },
            align: "center",
            arrowhead: 7,
            // arrowsize: 0.5,
            // arrowwidth: 2,
            arrowcolor: "#58B19F",
            ax: 20,
            ay: -30,
            // bordercolor: "#c7c7c7",
            // borderwidth: 2,
            borderpad: 4,
            bgcolor: "#58B19F",
            opacity: 0.8
          },
          {
            x: new Date((this.attributeData[element].find(element1 => element1.value === minValue))?.timestamp),
            y: minValue,
            xref: "x",
            yref: "y",
            text: "Min value=" + minValue.toString(),
            showarrow: true,
            font: {
              family: "Inter",
              size: 12,
              color: "#ffffff"
            },
            align: "center",
            arrowhead: 7,
            // arrowsize: 0.5,
            // arrowwidth: 2,
            arrowcolor: "#58B19F",
            ax: 20,
            ay: -30,
            // bordercolor: "#c7c7c7",
            // borderwidth: 2,
            borderpad: 4,
            bgcolor: "#58B19F",
            opacity: 0.8
          }
        ] : []
      };
      attributeBarData.tabTitle = element;
      statisticsAttributeData.attributeData = [];
      const notes = this.attributeData[element].map((item: any) => item.notes ? '<span style="color:#01908E;font-size: 25px;width:100%;">%{y}</span>,  %{x}<br><span style="font-size: 15px;">Notes:</span><br><b>' + item?.notes?.value + '</b><br> <br>Last Updated By: <b>' + item?.notes?.author + '</b><br>' + this._datePipe.transform(item?.notes?.timestamp, 'MMM d, y, h:mm:ss a') + '<extra></extra>' :
        '<span style="color:#01908E;">%{y}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;%{x}  <br><br> <extra></extra>');
      const text = this.attributeData[element].map((item: any) => item.notes ? '📋' : '');
      const textposition = this.attributeData[element].map((item: any) => item.notes ? 'top' : '');
      const textSize = this.attributeData[element].map((item: any) => item.notes ? '16' : '');
      if (this.attributeData[element].every((item: any) => item.windowAvg) && this.tabData?.category !== 'patient') {
        attributeBarData2 = {
          x: this.attributeData[element].map(({ timestamp }) => new Date(timestamp)),
          y: this.attributeData[element].map(({ windowAvg }) => windowAvg),
          mode: 'lines+markers+text',
          connectgaps: true,
          title: '',
          margin: { l: 30, r: 10, b: 15, t: 0 },
          hovertemplate: '',
          width: 700,
          barColor: 'white',
          name: 'Simple Moving Average',
          line: {
            color: '#44BFCA'
          },
          marker: { color: '#097969', size: 4 },
        }
        attributeBarData2['hovertemplate'] = notes;
        attributeBarData2['text'] = text;
        attributeBarData2['textposition'] = textposition;
      }
      let absoluteTrendData;
      let rateTrendData;
      if (this._trendPlot) {
        Object.keys(this._trendPlot).forEach(ele => {
          if (element === ele) {
            absoluteTrendData = this._trendPlot?.[ele].find(e => e?.trend === 'absolute');
            rateTrendData = this._trendPlot?.[ele].find(e => e?.trend === 'rate');
            statistics['showTrend'] = (absoluteTrendData?.showTrend || rateTrendData?.showTrend) ? true : false;
            statistics['showHistory'] = (absoluteTrendData?.showHistory || rateTrendData?.showHistory) ? true : false;
            if (absoluteTrendData && absoluteTrendData?.value && absoluteTrendData?.showTrend) {
              attributeBarData3 = {
                x: absoluteTrendData?.plot.map(({ timestamp }) => new Date(timestamp)),
                y: absoluteTrendData?.plot.map(({ value }) => value),
                mode: 'lines+markers+text',
                connectgaps: true,
                title: '',
                margin: { l: 30, r: 10, b: 15, t: 0 },
                hovertemplate: '',
                width: 700,
                barColor: 'white',
                name: 'Trend-absolute',
                line: {
                  color: '#FFBF51',
                  dash: 'dot'
                },
                marker: { color: '#FF8C00', size: 20 },
              }
              statistics['absoluteTrendType'] = absoluteTrendData?.type;
              statistics['absoluteTrendPercentage'] = absoluteTrendData?.slopeValue;
              statistics['absoluteLastProcessedTimestamp'] = absoluteTrendData?.lastProcessedTimestamp;
              statistics['absoluteWindowSize'] = (this._subtractTime(new Date(absoluteTrendData?.lastProcessedTimestamp), absoluteTrendData?.windowSize))?.toISOString();
              attributeBarData3['hovertemplate'] = notes;
              attributeBarData3['text'] = text;
              attributeBarData3['textposition'] = textposition;
            }
            if (rateTrendData && rateTrendData?.value && rateTrendData?.showTrend) {
              attributeBarData4 = {
                x: rateTrendData?.plot.map(({ timestamp }) => new Date(timestamp)),
                y: rateTrendData?.plot.map(({ value }) => value),
                mode: 'lines+markers+text',
                connectgaps: true,
                title: '',
                margin: { l: 30, r: 10, b: 15, t: 0 },
                hovertemplate: '',
                width: 700,
                barColor: 'white',
                name: 'Trend -rate',
                line: {
                  color: '#7C83D0',
                  dash: 'dot'
                },
                marker: { color: '#6495ED', size: 4 },
              }
              statistics['rateTrendType'] = rateTrendData?.type;
              statistics['rateTrendPercentage'] = rateTrendData?.slopeValue;
              statistics['rateLastProcessedTimestamp'] = rateTrendData?.lastProcessedTimestamp;
              statistics['rateWindowSize'] = (this._subtractTime(new Date(rateTrendData?.lastProcessedTimestamp), rateTrendData?.windowSize))?.toISOString();
              attributeBarData4['hovertemplate'] = notes;
              attributeBarData4['text'] = text;
              attributeBarData4['textposition'] = textposition;
            }
          }
        })
      }
      attributeBarData['hovertemplate'] = notes;
      attributeBarData['text'] = text;
      attributeBarData['textposition'] = textposition;
      attributeBarData['textfont']['size'] = textSize;
      if (this.config.length) {
        const threshold = this.config.find((item: any) => item?.name?.toLowerCase() === element?.toLowerCase());
        if (threshold && Object.keys(threshold)?.length) {
          const lowerAlertThreshold = threshold.alertThreshold?.find((lower: any) => lower.name === 'lower');
          const upperAlertThreshold = threshold.alertThreshold?.find((upper: any) => upper.name === 'upper');
          const lowerDeviceThreshold = threshold.deviceThreshold?.find((lower: any) => lower.name === 'lower');
          const upperDeviceThreshold = threshold.deviceThreshold?.find((upper: any) => upper.name === 'upper');
          statistics['upperAlertThreshold'] = upperAlertThreshold?.threshold;
          statistics['lowerAlertThreshold'] = lowerAlertThreshold?.threshold;
          attributeBarData['marker'] = {
            color: this.attributeData[element].map((item: any) => {
              if (item.value <= +lowerAlertThreshold?.threshold) {
                attributeAlertLine.showAttributeLowerLine = true;
              }
              if (item.value >= +upperAlertThreshold?.threshold) {
                attributeAlertLine.showAttributeUpperLine = true;
              }
              if (item.value <= +lowerDeviceThreshold?.threshold) {
                attributeDeviceLine.deviceAttributeLowerLine = true;
              }
              if (item.value >= +upperDeviceThreshold?.threshold) {
                attributeDeviceLine.deviceAttributeUpperLine = true;
              }
              if (item.value >= +lowerAlertThreshold?.threshold && item.value <= +upperAlertThreshold?.threshold) {
                return '#097969';
              }
              else {
                invalidPointCount += 1;
                return '#D10000';
              }
            }),
            size: this.attributeData[element].map((item: any) => {
              if (item.value >= +lowerAlertThreshold?.threshold && item.value <= +upperAlertThreshold?.threshold) {
                return 4;
              }
              else {
                return 8;
              }
            })
          };
          if (attributeBarData2 && Object.keys(attributeBarData2)?.length) {
            attributeBarData2['marker'] = {
              color: this.attributeData[element].map((item: any) => {
                if (item.value <= +lowerAlertThreshold?.threshold) {
                  windowAlertLine.showWindowLowerLine = true;
                }
                if (item.value >= +upperAlertThreshold?.threshold) {
                  windowAlertLine.showWindowUpperLine = true;
                }
                if (item.value <= +lowerDeviceThreshold?.threshold) {
                  windowDeviceLine.deviceWindowLowerLine = true;
                }
                if (item.value >= +upperDeviceThreshold?.threshold) {
                  windowDeviceLine.deviceWindowUpperLine = true;
                }
                if (item.value >= +lowerAlertThreshold?.threshold && item.value <= +upperAlertThreshold?.threshold) {
                  return '#097969'
                }
                else {
                  return '#D10000'
                }
              }),
              size: this.attributeData[element].map((item: any) => {
                if (item.value >= +lowerAlertThreshold?.threshold && item.value <= +upperAlertThreshold?.threshold) {
                  return 4;
                }
                else {
                  return 8;
                }
              })
            };
          }
          if (lowerAlertThreshold && upperAlertThreshold) {
            attributeThresholdData['attributeThresholdMarker'] = {
              color: upperAlertThreshold?.colour,
              upper: +upperAlertThreshold?.threshold,
              lower: +lowerAlertThreshold?.threshold,
              showAttributeLowerLine: attributeAlertLine?.showAttributeLowerLine,
              showAttributeUpperLine: attributeAlertLine?.showAttributeUpperLine,
              showWindowLowerLine: windowAlertLine?.showWindowLowerLine,
              showWindowUpperLine: windowAlertLine?.showWindowUpperLine
            }
          }

          if (lowerDeviceThreshold && upperDeviceThreshold) {
            attributeThresholdData['deviceThresholdMarker'] = {
              color: upperDeviceThreshold?.colour,
              upper: +upperDeviceThreshold?.threshold,
              lower: +lowerDeviceThreshold?.threshold,
              deviceAttributeLowerLine: attributeDeviceLine.deviceAttributeLowerLine,
              deviceAttributeUpperLine: attributeDeviceLine.deviceAttributeUpperLine,
              deviceWindowLowerLine: windowDeviceLine.deviceWindowLowerLine,
              deviceWindowUpperLine: windowDeviceLine.deviceWindowUpperLine
            }
          }

        }
      }
      statisticsAttributeData.attributeData.push(attributeBarData);
      if (attributeBarData2 && Object.keys(attributeBarData2)?.length) {
        statisticsAttributeData.attributeData.push(attributeBarData2);
      }
      if (attributeBarData3 && Object.keys(attributeBarData3)?.length) {
        const lastCriticalValue = absoluteTrendData?.plot?.findLast((ele) => ele.type === 'critical');
        attributeBarData3['marker'] = {
          color: absoluteTrendData?.plot?.map((item: any) => {
            if (item === lastCriticalValue) {
              return '#a11f1f';
            } else {
              return '#FFBF51';
            }
          }),
          size: absoluteTrendData?.plot?.map((item: any) => {
            if (item === lastCriticalValue) {
              return 18;
            }
            else {
              return 8;
            }
          })
        }
        if (lastCriticalValue) {
          attributeBarData3['annotations'] = [
            {
              x: new Date(lastCriticalValue?.timestamp),
              y: lastCriticalValue?.value,
              xref: "x",
              yref: "y",
              text: "Critical value=" + lastCriticalValue?.value.toString(),
              showarrow: true,
              font: {
                family: "Inter",
                size: 14,
                color: "#ffffff"
              },
              align: "center",
              arrowhead: 7,
              // arrowsize: 1,
              // arrowwidth: 2,
              arrowcolor: "#FF0000",
              ax: 20,
              ay: -30,
              // bordercolor: "#c7c7c7",
              // borderwidth: 2,
              borderpad: 4,
              bgcolor: "#FF0000",
              opacity: 0.8
            },
          ]
        }
        statisticsAttributeData.attributeData.push(attributeBarData3);
      }
      if (attributeBarData4 && Object.keys(attributeBarData4)?.length) {
        const finalCriticalValue = rateTrendData?.plot?.findLast((ele) => ele.type === 'critical');
        attributeBarData4['marker'] = {
          color: rateTrendData?.plot?.map((item: any) => {
            if (item === finalCriticalValue) {
              return '#a11f1f';
            } else {
              return '#7C83D0';
            }
          }),
          size: rateTrendData?.plot?.map((item: any) => {
            if (item === finalCriticalValue) {
              return 18;
            }
            else {
              return 8;
            }
          })
        }
        if (finalCriticalValue) {
          attributeBarData4['annotations'] = [
            {
              x: new Date(finalCriticalValue?.timestamp),
              y: finalCriticalValue?.value,
              xref: "x",
              yref: "y",
              text: "Critical value=" + finalCriticalValue?.value.toString(),
              showarrow: true,
              font: {
                family: "Inter",
                size: 14,
                color: "#ffffff"
              },
              align: "center",
              arrowhead: 7,
              // arrowsize: 1,
              // arrowwidth: 2,
              arrowcolor: "#FF0000",
              ax: 20,
              ay: -30,
              // bordercolor: "#c7c7c7",
              // borderwidth: 2,
              borderpad: 4,
              bgcolor: "#FF0000",
              opacity: 0.8
            },
          ]
        }
        statisticsAttributeData.attributeData.push(attributeBarData4);
      }
      if (attributeThresholdData && Object.keys(attributeThresholdData)?.length) {
        statisticsAttributeData.attributeData.push(attributeThresholdData);
      }
      statistics['invalidPointCount'] = invalidPointCount;
      statisticsAttributeData.statisticsData = statistics;
      statisticsAttributeData.windowAverage = Math.round((this.attributeData[element][0].windowAvg) * 100) / 100;
      statisticsAttributeData.currentValue = this.attributeData[element].map(({ value }) => value)[0];
      this.attributeDataList.push(statisticsAttributeData);
    });
  }
  private _subtractTime(date, window) {
    const hour = date?.getHours() - window?.split(':')?.[0];
    const min = date?.getMinutes() - window?.split(':')?.[1];
    const sec = date?.getSeconds() - window?.split(':')?.[2];
    date?.setHours(hour);
    date?.setMinutes(min);
    date?.setSeconds(sec);
    return date;
  }
  private _getTrendData(showHistory: boolean = false, data: any, event: any) {
    const requestData = {
      entityId: this.tabData?._id,
      from: this._datePipe.transform(this._startTime, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this._endTime ? this._endTime : Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ'),
    };
    this._getTrendChartDetailsSubscription = this._entityService.getTrendChartDetails(requestData, showHistory ? event.checked : false).subscribe(
      {
        next: (result: any) => {
          if (result) {
            this.isloader = false;
            Object.keys(result)?.forEach(e => {
              result[e]?.map(item => {
                const trendArray = this.attributeList?.find(ele => ele?.attribute === e);
                const absoluteTrend = trendArray?.trend?.find(trends => trends?.type === 'absolute');
                const rateTrend = trendArray?.trend?.find(trends => trends?.type === 'rate');
                if (item?.trend === 'absolute') {
                  item['value'] = absoluteTrend?.value;
                }
                if (item?.trend === 'rate') {
                  item['value'] = rateTrend?.value;
                }
              })
            })
            this._trendPlot = result;
            const absoluteTrendData = this._trendPlot?.[data]?.find(e => e?.trend === 'absolute');
            const rateTrendData = this._trendPlot?.[data]?.find(e => e?.trend === 'rate');
            if (event.checked === true) {
              if ((absoluteTrendData && Object.keys(absoluteTrendData)?.length) || (rateTrendData && Object.keys(rateTrendData)?.length)) {
                if (absoluteTrendData?.value || rateTrendData?.value) {
                  if (absoluteTrendData) {
                    absoluteTrendData['showTrend'] = true;
                    absoluteTrendData['showHistory'] = showHistory ? true : false;
                  }
                  if (rateTrendData) {
                    rateTrendData['showTrend'] = true;
                    rateTrendData['showHistory'] = showHistory ? true : false;
                  }
                } else {
                  this.service.toasterService({ type: 'warning', msg: 'Trend not activated. Please follow the path profile->digitaltwin image->attribute to activate' });
                }
              } else {
                this.service.toasterService({ type: 'warning', msg: 'Trend not available' });
              }
            }
            else {
              if (absoluteTrendData) {
                if (!showHistory) {
                  absoluteTrendData['showTrend'] = false;
                } else {
                  absoluteTrendData['showTrend'] = true;
                  absoluteTrendData['showHistory'] = false;
                }
              }
              if (rateTrendData) {
                if (!showHistory) {
                  rateTrendData['showTrend'] = false;
                } else {
                  rateTrendData['showTrend'] = true;
                  rateTrendData['showHistory'] = false;
                }
              }
            }
            if (this.attributeData) {
              this._plotAttributeGraph();
            }
          }
        },
        error: () => {
          this.isloader = false;
          this.isError = true;
        }
      })
  }

  // activeEntityDetails(pageNo?: number) {
  //   this.currentStatHistoryPage = pageNo ? pageNo : this.currentStatHistoryPage;
  //   const startDate = new Date(this._datePicker?.value.getFullYear(), this._datePicker?.value.getMonth(), this._datePicker?.value.getDate(), 0, 0, 0, 999);
  //   const endDate = new Date(this._datePicker?.value.getFullYear(), this._datePicker?.value.getMonth(), this._datePicker?.value.getDate(), 23, 59, 59, 999);
  //   const requestData = {
  //     siteId: this.service.getSiteId(),
  //     // entityCategory: 'patient',
  //     // from: type === 'next' ? this.previousDate : this._datePipe.transform(this._startTime, 'yyyy-MM-ddTHH:mm:ssZZ'),
  //     from: this._datePipe.transform(startDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
  //     to: this._datePipe.transform(endDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
  //     entityId: this.tabData?._id,
  //     count: this.pageSize?.value
  //   };
  //   this.widgetService.activeEntityDetails(requestData, pageNo).subscribe({
  //     next: (result: any) => {
  //       if (result['status']) {
  //         if (result['response']['data']?.length) {
  //           let transformedCurrentData = [];
  //           [...result['response']['data']].forEach((item: any) => {
  //             const transformedCurrentObj = this.service.flattenObject(item, 'vitals');
  //             transformedCurrentData.push(transformedCurrentObj);
  //           });
  //           this.transformedTrlData = transformedCurrentData;
  //           this.transformedTrlData.map((elem: any) => {
  //             elem['time'] = this.service.getLastSeenFormat(elem.sourceTimestamp);
  //             if (!elem['attrValid']) {
  //               elem['attrValid'] = false;
  //             }
  //           });
  //           transformedCurrentData = [];
  //           if (result['response']['pageInfo']) {
  //             this.totalPages = result?.response?.pageInfo?.pages?.length;
  //           }
  //         } else {
  //           this.transformedTrlData = [];
  //           this.totalPages = [];
  //           if (result?.response?.message)
  //             this.service.toasterService({ type: 'error', msg: result?.response?.message });
  //         }
  //       }
  //       else {
  //         this.transformedTrlData = [];
  //         if (result?.response?.message)
  //           this.service.toasterService({ type: 'error', msg: result?.response?.message });
  //       }
  //       this.isloader = false;
  //     }, error: (error) => {
  //       if (error) {
  //         this.transformedTrlData = [];
  //         this.isloader = false;
  //       }
  //     }
  //   });
  // }

  // onPaginateChange(page: number) {
  //   this.activeEntityDetails(page);
  // }

  // onStatPaginateChange(page: number, index: number) {
  //   this._rulStatistictsData[index].currentRulStatPage = page;
  //   this.getRulStatistics(this._rulStatistictsData[index]?.rulType);
  // }

  // getRulStatistics(classType: string) {
  //   const startDate = new Date(this._datePicker?.value.getFullYear(), this._datePicker?.value.getMonth(), this._datePicker?.value.getDate(), 0, 0, 0, 999);
  //   const endDate = new Date(this._datePicker?.value.getFullYear(), this._datePicker?.value.getMonth(), this._datePicker?.value.getDate(), 23, 59, 59, 999);
  //   const requestData = {
  //     count: this.pageSize?.value,
  //     from: this._datePipe.transform(startDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
  //     to: this._datePipe.transform(endDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
  //     entityId: this.tabData?._id,
  //     class: classType === 'brake' ? 'RUL_BRAKE_PAD' : 'RUL_CLUTCH_PAD',
  //   };
  //   const page = this._rulStatistictsData?.find((elem: any) => elem?.rulType === classType)?.currentRulStatPage;
  //   this.entityService.rulStatistics(requestData, page).subscribe({
  //     next: (result: any) => {
  //       if (result?.data && result?.data?.length) {
  //         if (classType === 'brake') {
  //           this.brakeRulChart = this.setChartData(result?.data, classType);
  //           result?.data?.map((elem: any) =>
  //             elem.time = this.service.getLastSeenFormat(elem.processedTime));
  //           this._rulStatistictsData.find((elem: any) => elem?.rulType === 'brake').totalPages = result?.pageInfo?.pages?.length;
  //           this.brakeRulStat = result?.data;
  //         } else {
  //           this.clutchRulChart = this.setChartData(result?.data, classType);
  //           result?.data?.map((elem: any) => elem.time = this.service.getLastSeenFormat(elem.processedTime));
  //           this._rulStatistictsData.find((elem: any) => elem?.rulType === 'clutch').totalPages = result?.pageInfo?.pages?.length;
  //           this.clutchRulStat = result?.data;
  //         }
  //       } else {
  //         if (classType === 'brake') {
  //           this.brakeRulStat = [];
  //           this.brakeRulChart = [];
  //           this._rulStatistictsData.find((elem: any) => elem?.rulType === 'brake').totalPages = result?.pageInfo?.pages?.length;
  //         } else {
  //           this.clutchRulStat = [];
  //           this.clutchRulChart = [];
  //           this._rulStatistictsData.find((elem: any) => elem?.rulType === 'clutch').totalPages = result?.pageInfo?.pages?.length;
  //         }
  //       }
  //     },
  //     error: () => {
  //       this.brakeRulStat = [];
  //       this.clutchRulStat = [];
  //     }
  //   })
  // }

  // setChartData(data: any, classType: string) {
  //   return [[
  //     {
  //       x: data?.map(({ processedTime }) => new Date(processedTime)),
  //       y: data?.map(({ odometerValue }) => odometerValue),
  //       name: 'Odometer',
  //       type: 'scatter',
  //       mode: 'lines+markers',
  //       line: {
  //         color: '#055C7B'
  //       },
  //       legend: {
  //         x: .8,
  //         y: 1.2,
  //         orientation: "h"
  //       }
  //     },
  //     {
  //       x: data?.map(({ processedTime }) => new Date(processedTime)),
  //       y: data?.map(({ rulValue }) => rulValue),
  //       name: classType === 'brake' ? 'Brake RUL' : 'Clutch RUL',
  //       yaxis: 'y2',
  //       type: 'scatter',
  //       mode: 'lines+markers',
  //       line: {
  //         color: '#4BA0BE'
  //       }
  //     }
  //   ]];
  // }

  // toggleChart(index: number) {
  //   this._rulStatistictsData[index].isChart = !this._rulStatistictsData[index].isChart;
  // }

  // tableAction(event: any) {
  //   if (event?.type === 'view') {
  //     this.dialog.open(RulStatDialogComponent, {
  //       width: '40%',
  //       data: { msg: 'Summary', item: event?.item },
  //       disableClose: true
  //     });
  //   } else if (event?.type === 'flag') {
  //     this.setFlagDetails(event);
  //   }
  // }

  // setFlagDetails(event: any) {
  //   const reqData = {
  //     data: {
  //       attrValid: !event?.item?.attrValid
  //     },
  //     _id: event?.item?._id
  //   };
  //   this.entityService.updateEntityData(reqData).subscribe((result: any) => {
  //     if (result['status']) {
  //       this.service.toasterService({ type: 'success', msg: result?.response?.message });
  //       this.dataSer.broadcast('vitalHistoryRefresh');
  //     } else {
  //       this.service.toasterService({ type: 'error', msg: result?.response?.message });
  //     }
  //   });
  // }

  // onDateChange(type: string, event: any) {
  //   this.trlFetchData();
  // }

}
